import React from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';

const PhoneNumberFormat = React.forwardRef((props, ref) => {
  const { onChange, name, ...other } = props;

  const setRef = React.useCallback(
    (maskedInputRef) => {
      const value = maskedInputRef ? maskedInputRef.inputElement : null;

      if (typeof ref === 'function') {
        ref(value);
      } else if (ref) {
        ref.current = value;
      }
    },
    [ref],
  );

  const telephoneMask = (val) => {
    if (val.length < 10 || val.substr(0, 1) !== '0') {
      let dig0 = val.substring(0, 2);
      let dig1 = val.substring(2, 5);
      let dig2 = val.substring(5, 7);
      let dig3 = val.substring(7, 9);
      return dig0 + ' ' + dig1 + ' ' + dig2 + ' ' + dig3;
    } else {
      let dig0 = val.substring(0, 3);
      let dig1 = val.substring(3, 6);
      let dig2 = val.substring(6, 8);
      let dig3 = val.substring(8, 10);
      return dig0 + ' ' + dig1 + ' ' + dig2 + ' ' + dig3;
    }
  }

  return (
    <NumberFormat
      {...other}
      getInputRef={setRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: name,
            value: values.value,
          },
        });
      }}
      allowNegative={false}
      isNumericString
      decimalScale={0}
      format={telephoneMask}
    />
  );
});

PhoneNumberFormat.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default PhoneNumberFormat;